import { render, staticRenderFns } from "./BottomSheetNotGranted.vue?vue&type=template&id=1fef1a2e&scoped=true&"
import script from "./BottomSheetNotGranted.vue?vue&type=script&lang=js&"
export * from "./BottomSheetNotGranted.vue?vue&type=script&lang=js&"
import style0 from "./BottomSheetNotGranted.vue?vue&type=style&index=0&id=1fef1a2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fef1a2e",
  null
  
)

component.options.__file = "BottomSheetNotGranted.vue"
export default component.exports